export default {
    "sidebar.home": "Inicio",
    "sidebar.dashboard": "Panel",
    "sidebar.products": "Productos",
    "sidebar.products.all": "Listado",
    "sidebar.products.add": "Nuevo",
    "sidebar.products.stock": "Inventario",
    "sidebar.products.ml.list": "Publis ML",
    "sidebar.messages": "Mensajes",
    "sidebar.users": "Usuarios",
    "sidebar.support": "Mesa de ayuda",
    "sidebar.settings": "Configuraciones",
    "sidebar.orders": "Pedidos",
    "sidebar.orders.list": "Listado",
    "sidebar.orders.add": "Nuevo",
}